module.exports = __webpack_public_path__ + "static/media/Loading Bar.eef5f618.gif";